import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface EmailTemplatesState {
  filters?: {
    searchText?: string;
    createdById?: number;
  };
  pagination: {
    itemsPerPage: number;
    currentPage: number;
  };
}

const initialState: EmailTemplatesState = {
  filters: {
    searchText: '',
    createdById: undefined,
  },
  pagination: {
    itemsPerPage: 10,
    currentPage: 1,
  },
};

export const emailTemplatesSlice = createSlice({
  name: 'emailTemplates',
  initialState,
  reducers: {
    setEmailTemplateFilter: (state, action: PayloadAction<Partial<EmailTemplatesState['filters']>>) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    setEmailTemplatePagination: (state, action: PayloadAction<Partial<EmailTemplatesState['pagination']>>) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
  },
});

export const {
  setEmailTemplateFilter,
  setEmailTemplatePagination,
} = emailTemplatesSlice.actions;

export default emailTemplatesSlice.reducer;
